import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation } from 'app/mock-api/common/navigation/data';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NavigationMockApi {
    private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
    private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;

    /**
     * Constructor
     */
    // NavigationMenu: FuseNavigationItem[];
    // defaultNavigationData: FuseNavigationItem[];
    navigationData :any; 
    constructor(private _fuseMockApiService: FuseMockApiService) {
        // this._instantiateData();
        // Register Mock API handlers
        this.registerHandlers();
        // this.getMenuData();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        console.log("Register Handlers called!!!");
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {

                // Fill compact navigation children using the default navigation
                // this._compactNavigation.forEach((compactNavItem) => {
                //     this._defaultNavigation.forEach((defaultNavItem) => {
                //         if ( defaultNavItem.id === compactNavItem.id )
                //         {
                //             compactNavItem.children = cloneDeep(defaultNavItem.children);
                //         }
                //     });
                // });

                // // Fill futuristic navigation children using the default navigation
                // this._futuristicNavigation.forEach((futuristicNavItem) => {
                //     this._defaultNavigation.forEach((defaultNavItem) => {
                //         if ( defaultNavItem.id === futuristicNavItem.id )
                //         {
                //             futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                //         }
                //     });
                // });
                let NavigationMenu : FuseNavigationItem[];
                let defaultNavigationData: FuseNavigationItem[];
                let orgId = sessionStorage.getItem('orgId');
                console.log(orgId);

                let role = sessionStorage.getItem('activeRole');
                let lstIndx = role.lastIndexOf('(');
                role = role.slice(0,lstIndx);
                console.log(role);

                if (role==='it-ops-admin'){
                    NavigationMenu = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project',
                            link: 'marketplace/hrg-req/lst-vw',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'marketplace',
                            title   : 'Marketplace',
                            type    : 'group',
                            icon    : 'heroicons_outline:library',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'operations',
                            title   : 'Platform Mgmt',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        },
                    ];
                    defaultNavigationData = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project'
                            link: 'marketplace/hrg-req/lst-vw',
                        },
                        {
                            id: 'marketplace',
                            title: 'Marketplace2',
                            type: 'group',
                            icon: 'heroicons_outline:library',
                            children: [
                                {
                                    id: 'marketplace.jobs',
                                    title: 'Jobs',
                                    type: 'basic',
                                    icon: 'heroicons_outline:briefcase',
                                    link: 'marketplace/hrg-req/lst-vw',
                                    // link: '/marketplace/job/hrg-req/lst-vw'
                                },
                            ]
                        },
                        {
                            id      : 'operations',
                            title   : 'Platform',
                            type    : 'group',
                            icon    : 'mat_outline:wrench',
                            children: [
                                {
                                    id: 'operations.ux',
                                    title: 'UX Layout',
                                    type: 'basic',
                                    icon: 'heroicons_outline:cog',
                                    link: '/ops/ux-conf/ui-view-lyt-conf/lst-vw'
                                },
                                {
                                    id: 'operations.refdata',
                                    title: 'Reference Data',
                                    type: 'basic',
                                    icon: 'heroicons_outline:database',
                                    link: '/ops/ref-data/ref-typ/lst-vw'
                                },
                                {
                                    id   : 'operations.evnt',
                                    title: 'Event',
                                    type : 'basic',
                                    icon : 'heroicons_outline:inbox',
                                    link : '/ops/event/evnt/lst-vw'
                                },         
                            ]
                        } ,
                       
                    ];
                }
                
                else if(role==='bus-ops-admin'){
                    NavigationMenu = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project',
                            link: 'marketplace/hrg-req/lst-vw', 
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'hiring',
                            title   : 'Hiring',
                            type    : 'group',
                            icon    : 'heroicons_outline:briefcase',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'marketplace',
                            title   : 'Marketplace',
                            type    : 'group',
                            icon    : 'heroicons_outline:library',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'dashboards',
                            title   : 'Analytics',
                            type    : 'group',
                            icon    : 'heroicons_outline:presentation-chart-bar',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        },
                        {
                            id      : 'operations',
                            title   : 'Platform Mgmt',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        },
                        {
                            id      : 'admin',
                            title   : 'Admin',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        },
                        {
                            id      : 'worklist',
                            title   : 'My Worklist',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        },
                    ];
                
                    defaultNavigationData = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project'
                            link: 'marketplace/hrg-req/lst-vw',
                        },
                        {
                            id      : 'hiring',
                            title   : 'Hiring',
                            type    : 'group',
                            icon    : 'heroicons_outline:briefcase',
                            children: [   
                                        // {
                                        //     id   : 'hiring.setup',
                                        //     title: 'Setup',
                                        //     type : 'collapsable',
                                        //     icon : 'heroicons_outline:document-text',
                                        //     children:[
                                        //         {
                                        //             id   : 'hiring.jd',
                                        //             title: 'View JDs',
                                        //             type : 'basic',
                                        //             icon : 'heroicons_outline:document-text',
                                        //             link : '/hiring/jd/lst-vw'
                                        //         },  
                                        //         // {
                                        //         //     id   : 'admin.meeting',
                                        //         //     title: 'Meeting',
                                        //         //     type: 'basic',
                                        //         //     icon: 'mat_outline:meeting_room',
                                        //         //     link: '/admin/meeting/lst-vw'
                                        //         // },  
                                        //         // {
                                        //         //     id   : 'hiring.assessment-tmpl',
                                        //         //     title: 'Job Qualifications',
                                        //         //     type : 'basic',
                                        //         //     icon : 'heroicons_outline:template',
                                        //         //     link : '/hiring/job-qual/lst-vw'
                                        //         // },
                                        //         // {
                                        //         //     id   : 'hiring.assessment-tmpl',
                                        //         //     title: 'Interview Template',
                                        //         //     type : 'basic',
                                        //         //     icon : 'heroicons_outline:template',
                                        //         //     link : '/hiring/asmt-tmpl/lst-vw'
                                        //         // },
                                        //         // {
                                        //         //     id   : 'hiring.assessment-tmpl',
                                        //         //     title: 'Interview Questions',
                                        //         //     type : 'basic',
                                        //         //     icon : 'heroicons_outline:template',
                                        //         //     link : '/hiring/asmt-ques/lst-vw'
                                        //         // }                                  
                                        //     ]
                                        // },
                                        // {
                                        //     id   : 'hiring.uploadJd',
                                        //     title: 'Upload JDs',
                                        //     type : 'basic',
                                        //     icon : 'heroicons_outline:document-text',
                                        //     link : '/upload/jd/lst-vw'                        
                                        // },
                                        {
                                            id   : 'hiring.viewHrgReqs',
                                            title: 'Hiring Requests',
                                            type : 'basic',
                                            icon : 'heroicons_outline:document-search',
                                            link : '/hiring/hrg-req/lst-vw'
                                        },
                                        {
                                            id   : 'hiring.viewCndtWkfws',
                                            title: 'CV Submissions',
                                            type : 'basic',
                                            icon : 'heroicons_outline:clipboard-list',
                                            link : '/hiring/cv-subm/cndt-Wkfw/lst-vw'                        
                                        },                    
                                    ]
                        },
                        {
                            id: 'marketplace',
                            title: 'Marketplace2',
                            type: 'group',
                            icon: 'heroicons_outline:library',
                            children: [
                                {
                                    id: 'marketplace.rctr',
                                    title: 'Recruiters',
                                    type: 'basic',
                                    icon: 'mat_solid:person_search',
                                    link: '/marketplace/rctr/rctr/lst-vw'
                                },
                                {
                                    id: 'marketplace.candidates',
                                    title: 'Candidates',
                                    type: 'basic',
                                    icon: 'mat_solid:person_outline',
                                    link: '/marketplace/cndt/cndt/lst-vw'
                                },
                                {
                                    id: 'marketplace.jobs',
                                    title: 'Jobs',
                                    type: 'basic',
                                    icon: 'heroicons_outline:briefcase',
                                    link: 'marketplace/hrg-req/lst-vw',
                                    // link: '/marketplace/job/hrg-req/lst-vw'
                                }
                            ]
                        },
                        {
                            id      : 'dashboards',
                            title   : 'Analytics',
                            type    : 'group',
                            icon    : 'heroicons_outline:presentation-chart-bar',
                            children: [
                                {
                                    id   : 'dashboards.customer',
                                    title: 'Customer Insights',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-check',
                                    link : '/dashboards/quicksight/clientTracker'
                                },
                                {
                                    id   : 'dashboards.hiring',
                                    title: 'Hiring Dashboard',
                                    type : 'basic',
                                    icon : 'heroicons_outline:chart-pie',
                                    link : '/dashboards/quicksight/hiringTracker'
                                },
                                {
                                    id   : 'dashboards.ops',
                                    title: 'Operations Tracker',
                                    type : 'basic',
                                    icon : 'heroicons_outline:chart-pie',
                                    link : '/dashboards/quicksight/opsTracker'
                                }
                            ]
                        },
                        {
                            id      : 'operations',
                            title   : 'Platform',
                            type    : 'group',
                            icon    : 'mat_outline:wrench',
                            children: [
                                {
                                    id: 'operations.org',
                                    title: 'Orgs',
                                    type: 'basic',
                                    icon: 'heroicons_outline:office-building',
                                    link: '/ops/org/org/lst-vw'
                                },
                                {
                                    id: 'operations.usr',
                                    title: 'Users',
                                    type: 'basic',
                                    icon: 'heroicons_outline:user',
                                    link: '/ops/usr/usr/lst-vw'
                                }       
                            ]
                        } ,
                        {
                            id      : 'worklist',
                            title   : 'My Worklist',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [
                                {
                                    id: 'operations.regn',
                                    title: 'Registrations',
                                    type: 'basic',
                                    icon: 'heroicons_outline:office-building',
                                    link: '/ops/regn/lst-vw'
                                },
                                {
                                    id: 'operations.tasks',
                                    title: 'My Tasks',
                                    type: 'basic',
                                    icon: 'mat_outline:add_task',
                                    link: '/ops/task/lst-vw'
                                },
                                {
                                    id: 'operations.invoices',
                                    title: 'Invoices',
                                    type: 'basic',
                                    icon: 'mat_outline:add_task',
                                    link: '/ops/invc/lst-vw'
                                },        
                            ]
                        },
                        {
                            id      : 'admin',
                            title   : 'Admin',
                            type    : 'group',
                            icon    : 'mat_outline:wrench',
                            children: [
                                {
                                    id   : 'hiring.viewJds',
                                    title: 'JDs',
                                    type : 'basic',
                                    icon : 'heroicons_outline:document-text',
                                    link : '/hiring/jd/lst-vw'                        
                                },
                                {
                                    id: 'admin.org',
                                    title: 'Org',
                                    type: 'basic',
                                    icon: 'heroicons_outline:office-building',
                                    link: `/ops/org/org/dtl-vw/${orgId}`
                                },
                                {
                                    id: 'admin.usr',
                                    title: 'Users',
                                    type: 'basic',
                                    icon: 'heroicons_outline:user',
                                    link: '/admin/usr/usr/lst-vw'
                                },
                                {
                                    id   : 'admin.wkfw-tmpl',
                                    title: 'Assessment Workflows',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-list',
                                    link : '/admin/wkfw-tmpl/lst-vw'
                                },     
                                {
                                    id   : 'operations.comm-mdl',
                                    title: 'Commission Model',
                                    type : 'basic',
                                    icon : 'heroicons_outline:currency-rupee',
                                    link : '/ops/comm-mdl/lst-vw'
                                },   
                                {
                                    id   : 'admin.reset-password',
                                    title: 'Reset Password',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-list',
                                    link : '/admin/reset-password'
                                }         
                                
                            ]
                        },
                       
                    ];
                }
                
                else if(role==='bus-ops'){
                    NavigationMenu = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project',
                            link: 'marketplace/hrg-req/lst-vw',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'marketplace',
                            title   : 'Marketplace',
                            type    : 'group',
                            icon    : 'heroicons_outline:library',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'recruiter',
                            title   : 'Recruiter',
                            type    : 'group',
                            icon    : 'heroicons_outline:briefcase',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'admin',
                            title   : 'Org Mgmt',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        }
                    ];
                }
                
                else if(role==='rctr-admin'){
                    NavigationMenu = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project',
                            link: 'marketplace/hrg-req/lst-vw',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'marketplace',
                            title   : 'Marketplace',
                            type    : 'group',
                            icon    : 'heroicons_outline:library',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'recruiter',
                            title   : 'Recruiter',
                            type    : 'group',
                            icon    : 'heroicons_outline:briefcase',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'dashboards',
                            title   : 'Analytics',
                            type    : 'group',
                            icon    : 'heroicons_outline:presentation-chart-bar',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        },
                        {
                            id      : 'worklist',
                            title   : 'My Worklist',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        },
                        {
                            id      : 'admin',
                            title   : 'Admin',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        }
                    ];
                    defaultNavigationData = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project'
                            link: 'marketplace/hrg-req/lst-vw',
                        },
                        {
                            id: 'marketplace',
                            title: 'Marketplace2',
                            type: 'group',
                            icon: 'heroicons_outline:library',
                            children: [
                                {
                                    id: 'marketplace.jobs',
                                    title: 'Jobs',
                                    type: 'basic',
                                    icon: 'heroicons_outline:briefcase',
                                    link: 'marketplace/hrg-req/lst-vw',
                                    // link: '/marketplace/job/hrg-req/lst-vw'
                                },
                            ]
                        },
                        {
                            id      : 'recruiter',
                            title   : 'Recruiter',
                            type    : 'group',
                            icon    : 'heroicons_outline:briefcase',
                            children: [
                                {
                                    id   : 'recruiter.mycv',
                                    title: 'My CV',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-check',
                                    link : '/recruiter/cndt/cndt/lst-vw'
                                },
                                {
                                    id: 'admin.candidates',
                                    title: 'Upload CV',
                                    type: 'basic',
                                    icon: 'mat_solid:person_outline',
                                    link: '/hiring/upload/cv'
                                },
                                // {
                                //     id   : 'recruiter.myjobs',
                                //     title: 'My Jobs',
                                //     type : 'basic',
                                //     icon : 'heroicons_outline:briefcase',
                                //     link: 'marketplace/hrg-req/lst-vw',
                                // },
                                {
                                    id   : 'recruiter.submissions',
                                    title: 'My Submissions',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-check',
                                    link : '/hiring/cv-subm/cndt-Wkfw/lst-vw'
                                },
                            ]
                        
                        },
                        {
                            id      : 'dashboards',
                            title   : 'Analytics',
                            type    : 'group',
                            icon    : 'heroicons_outline:presentation-chart-bar',
                            children: [
                                {
                                    id   : 'dashboards.customer',
                                    title: 'Customer Insights',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-check',
                                    link : '/dashboards/quicksight/clientTracker'
                                },
                                {
                                    id   : 'dashboards.hiring',
                                    title: 'Hiring Dashboard',
                                    type : 'basic',
                                    icon : 'heroicons_outline:chart-pie',
                                    link : '/dashboards/quicksight/hiringTracker'
                                },
                                {
                                    id   : 'dashboards.ops',
                                    title: 'Operations Tracker',
                                    type : 'basic',
                                    icon : 'heroicons_outline:chart-pie',
                                    link : '/dashboards/quicksight/opsTracker'
                                }
                            ]
                        },
                        {
                            id      : 'admin',
                            title   : 'Admin',
                            type    : 'group',
                            icon    : 'mat_outline:wrench',
                            children: [
                                {
                                    id: 'admin.org',
                                    title: 'Org',
                                    type: 'basic',
                                    icon: 'heroicons_outline:office-building',
                                    link: `/ops/org/org/dtl-vw/${orgId}`
                                },
                                {
                                    id: 'admin.usr',
                                    title: 'Users',
                                    type: 'basic',
                                    icon: 'heroicons_outline:user',
                                    link: '/admin/usr/usr/lst-vw'
                                },       
                                {
                                    id   : 'admin.reset-password',
                                    title: 'Reset Password',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-list',
                                    link : '/admin/reset-password'
                                }         
                                
                            ]
                        },
                        {
                            id      : 'worklist',
                            title   : 'My Worklist',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [
                                {
                                    id: 'operations.tasks',
                                    title: 'My Tasks',
                                    type: 'basic',
                                    icon: 'mat_outline:add_task',
                                    link: '/ops/task/lst-vw'
                                }      
                            ]
                        }
                       
                    ];
                }
                
                else if(role==='rctr'){
                    NavigationMenu = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project',
                            link: 'marketplace/hrg-req/lst-vw',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'marketplace',
                            title   : 'Marketplace',
                            type    : 'group',
                            icon    : 'heroicons_outline:library',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'recruiter',
                            title   : 'Recruiter',
                            type    : 'group',
                            icon    : 'heroicons_outline:briefcase',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'dashboards',
                            title   : 'Analytics',
                            type    : 'group',
                            icon    : 'heroicons_outline:presentation-chart-bar',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        },
                        {
                            id      : 'worklist',
                            title   : 'My Worklist',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        }
                    ];
                    defaultNavigationData = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project'
                            link: 'marketplace/hrg-req/lst-vw',
                        },
                        {
                            id: 'marketplace',
                            title: 'Marketplace2',
                            type: 'group',
                            icon: 'heroicons_outline:library',
                            children: [
                                {
                                    id: 'marketplace.jobs',
                                    title: 'Jobs',
                                    type: 'basic',
                                    icon: 'heroicons_outline:briefcase',
                                    link: 'marketplace/hrg-req/lst-vw',
                                    // link: '/marketplace/job/hrg-req/lst-vw'
                                },
                            ]
                        },
                        {
                            id      : 'recruiter',
                            title   : 'Recruiter',
                            type    : 'group',
                            icon    : 'heroicons_outline:briefcase',
                            children: [
                                {
                                    id   : 'recruiter.mycv',
                                    title: 'My CV',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-check',
                                    link : '/recruiter/cndt/cndt/lst-vw'
                                },
                                {
                                    id: 'admin.candidates',
                                    title: 'Upload CV',
                                    type: 'basic',
                                    icon: 'mat_solid:person_outline',
                                    link: '/hiring/upload/cv'
                                },
                                // {
                                //     id   : 'recruiter.myjobs',
                                //     title: 'My Jobs',
                                //     type : 'basic',
                                //     icon : 'heroicons_outline:briefcase',
                                //     link: 'marketplace/hrg-req/lst-vw',
                                // },
                                {
                                    id   : 'recruiter.submissions',
                                    title: 'My Submissions',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-check',
                                    link : '/hiring/cv-subm/cndt-Wkfw/lst-vw'
                                },
                            ]
                        
                        },
                        {
                            id      : 'dashboards',
                            title   : 'Analytics',
                            type    : 'group',
                            icon    : 'heroicons_outline:presentation-chart-bar',
                            children: [
                                {
                                    id   : 'dashboards.customer',
                                    title: 'Customer Insights',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-check',
                                    link : '/dashboards/quicksight/clientTracker'
                                },
                                {
                                    id   : 'dashboards.hiring',
                                    title: 'Hiring Dashboard',
                                    type : 'basic',
                                    icon : 'heroicons_outline:chart-pie',
                                    link : '/dashboards/quicksight/hiringTracker'
                                },
                                {
                                    id   : 'dashboards.ops',
                                    title: 'Operations Tracker',
                                    type : 'basic',
                                    icon : 'heroicons_outline:chart-pie',
                                    link : '/dashboards/quicksight/opsTracker'
                                }
                            ]
                        },
                        {
                            id      : 'worklist',
                            title   : 'My Worklist',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [
                                {
                                    id: 'operations.tasks',
                                    title: 'My Tasks',
                                    type: 'basic',
                                    icon: 'mat_outline:add_task',
                                    link: '/ops/task/lst-vw'
                                }      
                            ]
                        }
                       
                    ];
                }
                
                else if(role==='clnt-admin'){
                    NavigationMenu = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project',
                            link: 'marketplace/hrg-req/lst-vw',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'hiring',
                            title   : 'Hiring',
                            type    : 'group',
                            icon    : 'heroicons_outline:briefcase',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'marketplace',
                            title   : 'Marketplace',
                            type    : 'group',
                            icon    : 'heroicons_outline:library',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        },
                        {
                            id      : 'dashboards',
                            title   : 'Analytics',
                            type    : 'group',
                            icon    : 'heroicons_outline:presentation-chart-bar',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        },
                        {
                            id      : 'admin',
                            title   : 'Admin',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        },
                        {
                            id      : 'worklist',
                            title   : 'My Worklist',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        },
                    ];
                
                    defaultNavigationData = [
                        {
                            id      : 'home',
                            title   : 'Home',
                            type    : 'basic',
                            icon    : 'heroicons_outline:home',
                            // link    : '/dashboards/project'
                            link: 'marketplace/hrg-req/lst-vw',
                        },
                        {
                            id      : 'hiring',
                            title   : 'Hiring',
                            type    : 'group',
                            icon    : 'heroicons_outline:briefcase',
                            children: [ 
                                        {
                                            id   : 'hiring.viewHrgReqs',
                                            title: 'Hiring Requests',
                                            type : 'basic',
                                            icon : 'heroicons_outline:document-search',
                                            link : '/hiring/hrg-req/lst-vw'
                                        },
                                        {
                                            id   : 'hiring.viewCndtWkfws',
                                            title: 'CV Submissions',
                                            type : 'basic',
                                            icon : 'heroicons_outline:clipboard-list',
                                            link : '/hiring/cv-subm/cndt-Wkfw/lst-vw'                        
                                        },                    
                                    ]
                        },
                        {
                            id: 'marketplace',
                            title: 'Marketplace2',
                            type: 'group',
                            icon: 'heroicons_outline:library',
                            children: [
                                {
                                    id: 'marketplace.jobs',
                                    title: 'Jobs',
                                    type: 'basic',
                                    icon: 'heroicons_outline:briefcase',
                                    link: 'marketplace/hrg-req/lst-vw',
                                    // link: '/marketplace/job/hrg-req/lst-vw'
                                },
                                {
                                    id: 'marketplace.rctr',
                                    title: 'Recruiters',
                                    type: 'basic',
                                    icon: 'mat_solid:person_search',
                                    link: '/marketplace/rctr/rctr/lst-vw'
                                },
                                {
                                    id: 'marketplace.candidates',
                                    title: 'Candidates',
                                    type: 'basic',
                                    icon: 'mat_solid:person_outline',
                                    link: '/marketplace/cndt/cndt/lst-vw'
                                },
                            ]
                        },
                        {
                            id      : 'dashboards',
                            title   : 'Analytics',
                            type    : 'group',
                            icon    : 'heroicons_outline:presentation-chart-bar',
                            children: [
                                {
                                    id   : 'dashboards.customer',
                                    title: 'Customer Insights',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-check',
                                    link : '/dashboards/quicksight/clientTracker'
                                },
                                {
                                    id   : 'dashboards.hiring',
                                    title: 'Hiring Dashboard',
                                    type : 'basic',
                                    icon : 'heroicons_outline:chart-pie',
                                    link : '/dashboards/quicksight/hiringTracker'
                                },
                                {
                                    id   : 'dashboards.ops',
                                    title: 'Operations Tracker',
                                    type : 'basic',
                                    icon : 'heroicons_outline:chart-pie',
                                    link : '/dashboards/quicksight/opsTracker'
                                }
                            ]
                        },
                        {
                            id      : 'admin',
                            title   : 'Admin',
                            type    : 'group',
                            icon    : 'mat_outline:wrench',
                            children: [
                                {
                                    id   : 'hiring.viewJds',
                                    title: 'JDs',
                                    type : 'basic',
                                    icon : 'heroicons_outline:document-text',
                                    link : '/hiring/jd/lst-vw'                        
                                },
                                {
                                    id: 'admin.org',
                                    title: 'Org',
                                    type: 'basic',
                                    icon: 'heroicons_outline:office-building',
                                    link: `/ops/org/org/dtl-vw/${orgId}`
                                },
                                {
                                    id: 'admin.usr',
                                    title: 'Users',
                                    type: 'basic',
                                    icon: 'heroicons_outline:user',
                                    link: '/admin/usr/usr/lst-vw'
                                },
                                {
                                    id   : 'admin.wkfw-tmpl',
                                    title: 'Assessment Workflows',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-list',
                                    link : '/admin/wkfw-tmpl/lst-vw'
                                },     
                                {
                                    id   : 'operations.comm-mdl',
                                    title: 'Commission Model',
                                    type : 'basic',
                                    icon : 'heroicons_outline:currency-rupee',
                                    link : '/ops/comm-mdl/lst-vw'
                                },   
                                {
                                    id   : 'admin.reset-password',
                                    title: 'Reset Password',
                                    type : 'basic',
                                    icon : 'heroicons_outline:clipboard-list',
                                    link : '/admin/reset-password'
                                }         
                                
                            ]
                        },
                        {
                            id      : 'worklist',
                            title   : 'My Worklist',
                            type    : 'group',
                            icon    : 'heroicons_outline:cog',
                            children: [
                                {
                                    id: 'operations.regn',
                                    title: 'Registrations',
                                    type: 'basic',
                                    icon: 'heroicons_outline:office-building',
                                    link: '/ops/regn/lst-vw'
                                },
                                {
                                    id: 'operations.tasks',
                                    title: 'My Tasks',
                                    type: 'basic',
                                    icon: 'mat_outline:add_task',
                                    link: '/ops/task/lst-vw'
                                },
                                {
                                    id: 'operations.invoices',
                                    title: 'Invoices',
                                    type: 'basic',
                                    icon: 'mat_outline:add_task',
                                    link: '/ops/invc/lst-vw'
                                },        
                            ]
                        }
                       
                    ];
                }
                
                else{
                    NavigationMenu = [
                        // {
                        //     id      : 'home',
                        //     title   : 'Home',
                        //     type    : 'basic',
                        //     icon    : 'heroicons_outline:home',
                        //     link    : '/dashboards/project',
                        //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        // },
                        // {
                        //     id      : 'hiring',
                        //     title   : 'Hiring',
                        //     type    : 'group',
                        //     icon    : 'heroicons_outline:briefcase',
                        //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        // },
                        // {
                        //     id      : 'marketplace',
                        //     title   : 'Marketplace',
                        //     type    : 'group',
                        //     icon    : 'heroicons_outline:library',
                        //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        // },
                        // {
                        //     id      : 'recruiter',
                        //     title   : 'Recruiter',
                        //     type    : 'group',
                        //     icon    : 'heroicons_outline:briefcase',
                        //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        
                        // },
                        // {
                        //     id      : 'dashboards',
                        //     title   : 'Analytics',
                        //     type    : 'group',
                        //     icon    : 'heroicons_outline:presentation-chart-bar',
                        //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
                        // },
                        // {
                        //     id      : 'operations',
                        //     title   : 'Platform Mgmt',
                        //     type    : 'group',
                        //     icon    : 'heroicons_outline:cog',
                        //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        // },
                        // {
                        //     id      : 'worklist',
                        //     title   : 'My Worklist',
                        //     type    : 'group',
                        //     icon    : 'heroicons_outline:cog',
                        //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        // },
                        // {
                        //     id      : 'admin',
                        //     title   : 'Admin',
                        //     type    : 'group',
                        //     icon    : 'heroicons_outline:cog',
                        //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation    
                        // }
                    ];
                
                    defaultNavigationData = [
                            {
                                id      : 'home',
                                title   : 'Home',
                                type    : 'basic',
                                icon    : 'heroicons_outline:home',
                                link    : '/dashboards/project'
                            },
                            {
                                id      : 'hiring',
                                title   : 'Hiring',
                                type    : 'group',
                                icon    : 'heroicons_outline:briefcase',
                                children: [   
                                            // {
                                            //     id   : 'hiring.setup',
                                            //     title: 'Setup',
                                            //     type : 'collapsable',
                                            //     icon : 'heroicons_outline:document-text',
                                            //     children:[
                                            //         {
                                            //             id   : 'hiring.jd',
                                            //             title: 'View JDs',
                                            //             type : 'basic',
                                            //             icon : 'heroicons_outline:document-text',
                                            //             link : '/hiring/jd/lst-vw'
                                            //         },  
                                            //         // {
                                            //         //     id   : 'admin.meeting',
                                            //         //     title: 'Meeting',
                                            //         //     type: 'basic',
                                            //         //     icon: 'mat_outline:meeting_room',
                                            //         //     link: '/admin/meeting/lst-vw'
                                            //         // },  
                                            //         // {
                                            //         //     id   : 'hiring.assessment-tmpl',
                                            //         //     title: 'Job Qualifications',
                                            //         //     type : 'basic',
                                            //         //     icon : 'heroicons_outline:template',
                                            //         //     link : '/hiring/job-qual/lst-vw'
                                            //         // },
                                            //         // {
                                            //         //     id   : 'hiring.assessment-tmpl',
                                            //         //     title: 'Interview Template',
                                            //         //     type : 'basic',
                                            //         //     icon : 'heroicons_outline:template',
                                            //         //     link : '/hiring/asmt-tmpl/lst-vw'
                                            //         // },
                                            //         // {
                                            //         //     id   : 'hiring.assessment-tmpl',
                                            //         //     title: 'Interview Questions',
                                            //         //     type : 'basic',
                                            //         //     icon : 'heroicons_outline:template',
                                            //         //     link : '/hiring/asmt-ques/lst-vw'
                                            //         // }                                  
                                            //     ]
                                            // },
                                            // {
                                            //     id   : 'hiring.uploadJd',
                                            //     title: 'Upload JDs',
                                            //     type : 'basic',
                                            //     icon : 'heroicons_outline:document-text',
                                            //     link : '/upload/jd/lst-vw'                        
                                            // },
                                            {
                                                id   : 'hiring.viewHrgReqs',
                                                title: 'Hiring Requests',
                                                type : 'basic',
                                                icon : 'heroicons_outline:document-search',
                                                link : '/hiring/hrg-req/lst-vw'
                                            },
                                            {
                                                id   : 'hiring.viewCndtWkfws',
                                                title: 'CV Submissions',
                                                type : 'basic',
                                                icon : 'heroicons_outline:clipboard-list',
                                                link : '/hiring/cv-subm/cndt-Wkfw/lst-vw'                        
                                            },                    
                                        ]
                            },
                            {
                                id: 'marketplace',
                                title: 'Marketplace2',
                                type: 'group',
                                icon: 'heroicons_outline:library',
                                children: [
                                    {
                                        id: 'marketplace.jobs',
                                        title: 'Jobs',
                                        type: 'basic',
                                        icon: 'heroicons_outline:briefcase',
                                        link: 'marketplace/hrg-req/lst-vw',
                                        // link: '/marketplace/job/hrg-req/lst-vw'
                                    },
                                    {
                                        id: 'marketplace.rctr',
                                        title: 'Recruiters',
                                        type: 'basic',
                                        icon: 'mat_solid:person_search',
                                        link: '/marketplace/rctr/rctr/lst-vw'
                                    },
                                    // {
                                    //     id: 'marketplace.itwr',
                                    //     title: 'Interviewers',
                                    //     type: 'basic',
                                    //     icon: 'heroicons_outline:user-circle',
                                    //     link: '/marketplace/itwr/itwr/lst-vw'
                                    // },
                                    {
                                        id: 'marketplace.candidates',
                                        title: 'Candidates',
                                        type: 'basic',
                                        icon: 'mat_solid:person_outline',
                                        link: '/marketplace/cndt/cndt/lst-vw'
                                    },
                                ]
                            },
                            {
                                id      : 'recruiter',
                                title   : 'Recruiter',
                                type    : 'group',
                                icon    : 'heroicons_outline:briefcase',
                                children: [
                                    {
                                        id   : 'recruiter.mycv',
                                        title: 'My CV',
                                        type : 'basic',
                                        icon : 'heroicons_outline:clipboard-check',
                                        link : '/recruiter/cndt/cndt/lst-vw'
                                    },
                                    {
                                        id: 'admin.candidates',
                                        title: 'Upload CV',
                                        type: 'basic',
                                        icon: 'mat_solid:person_outline',
                                        link: '/hiring/upload/cv'
                                    },
                                    {
                                        id   : 'recruiter.myjobs',
                                        title: 'My Jobs',
                                        type : 'basic',
                                        icon : 'heroicons_outline:briefcase',
                                        link: 'marketplace/hrg-req/lst-vw',
                                    },
                                    {
                                        id   : 'recruiter.submissions',
                                        title: 'My Submissions',
                                        type : 'basic',
                                        icon : 'heroicons_outline:clipboard-check',
                                        link : '/hiring/cv-subm/cndt-Wkfw/lst-vw'
                                    },
                                ]
                            
                            },
                            {
                                id      : 'dashboards',
                                title   : 'Analytics',
                                type    : 'group',
                                icon    : 'heroicons_outline:presentation-chart-bar',
                                children: [
                                    {
                                        id   : 'dashboards.customer',
                                        title: 'Customer Insights',
                                        type : 'basic',
                                        icon : 'heroicons_outline:clipboard-check',
                                        link : '/dashboards/quicksight/clientTracker'
                                    },
                                    {
                                        id   : 'dashboards.hiring',
                                        title: 'Hiring Dashboard',
                                        type : 'basic',
                                        icon : 'heroicons_outline:chart-pie',
                                        link : '/dashboards/quicksight/hiringTracker'
                                    },
                                    {
                                        id   : 'dashboards.ops',
                                        title: 'Operations Tracker',
                                        type : 'basic',
                                        icon : 'heroicons_outline:chart-pie',
                                        link : '/dashboards/quicksight/opsTracker'
                                    }
                                ]
                            },
                            {
                                id      : 'operations',
                                title   : 'Platform',
                                type    : 'group',
                                icon    : 'mat_outline:wrench',
                                children: [
                                    {
                                        id: 'operations.org',
                                        title: 'Orgs',
                                        type: 'basic',
                                        icon: 'heroicons_outline:office-building',
                                        link: '/ops/org/org/lst-vw'
                                    },
                                    {
                                        id: 'operations.usr',
                                        title: 'Users',
                                        type: 'basic',
                                        icon: 'heroicons_outline:user',
                                        link: '/ops/usr/usr/lst-vw'
                                    },
                                    {
                                        id: 'operations.ux',
                                        title: 'UX Layout',
                                        type: 'basic',
                                        icon: 'heroicons_outline:cog',
                                        link: '/ops/ux-conf/ui-view-lyt-conf/lst-vw'
                                    },
                                    {
                                        id: 'operations.refdata',
                                        title: 'Reference Data',
                                        type: 'basic',
                                        icon: 'heroicons_outline:database',
                                        link: '/ops/ref-data/ref-typ/lst-vw'
                                    },
                                    {
                                        id   : 'operations.evnt',
                                        title: 'Event',
                                        type : 'basic',
                                        icon : 'heroicons_outline:inbox',
                                        link : '/ops/event/evnt/lst-vw'
                                    },
                                    {
                                        id   : 'operations.comm-mdl',
                                        title: 'Commission Model',
                                        type : 'basic',
                                        icon : 'heroicons_outline:currency-rupee',
                                        link : '/ops/comm-mdl/lst-vw'
                                    },
                                    {
                                        id   : 'operations.reset-password',
                                        title: 'Reset Password',
                                        type : 'basic',
                                        icon : 'heroicons_outline:clipboard-list',
                                        link : '/ops/reset-password'
                                    }            
                                ]
                            } ,
                            {
                                id      : 'admin',
                                title   : 'Admin',
                                type    : 'group',
                                icon    : 'mat_outline:wrench',
                                children: [
                                    {
                                        id   : 'hiring.viewJds',
                                        title: 'JDs',
                                        type : 'basic',
                                        icon : 'heroicons_outline:document-text',
                                        link : '/hiring/jd/lst-vw'                        
                                    },
                                    {
                                        id: 'admin.org',
                                        title: 'Org',
                                        type: 'basic',
                                        icon: 'heroicons_outline:office-building',
                                        link: `/ops/org/org/dtl-vw/${orgId}`
                                    },
                                    {
                                        id: 'admin.usr',
                                        title: 'Users',
                                        type: 'basic',
                                        icon: 'heroicons_outline:user',
                                        link: '/admin/usr/usr/lst-vw'
                                    },
                                    {
                                        id   : 'admin.wkfw-tmpl',
                                        title: 'Assessment Workflows',
                                        type : 'basic',
                                        icon : 'heroicons_outline:clipboard-list',
                                        link : '/admin/wkfw-tmpl/lst-vw'
                                    },        
                                    {
                                        id   : 'admin.reset-password',
                                        title: 'Reset Password',
                                        type : 'basic',
                                        icon : 'heroicons_outline:clipboard-list',
                                        link : '/admin/reset-password'
                                    }         
                                    
                                ]
                            },
                            {
                                id      : 'worklist',
                                title   : 'My Worklist',
                                type    : 'group',
                                icon    : 'heroicons_outline:cog',
                                children: [
                                    {
                                        id: 'operations.regn',
                                        title: 'Registrations',
                                        type: 'basic',
                                        icon: 'heroicons_outline:office-building',
                                        link: '/ops/regn/lst-vw'
                                    },
                                    {
                                        id: 'operations.tasks',
                                        title: 'My Tasks',
                                        type: 'basic',
                                        icon: 'mat_outline:add_task',
                                        link: '/ops/task/lst-vw'
                                    },
                                    {
                                        id: 'operations.invoices',
                                        title: 'Invoices',
                                        type: 'basic',
                                        icon: 'mat_outline:add_task',
                                        link: '/ops/invc/lst-vw'
                                    },        
                                ]
                            }
                           
                    ];
                }


                // Fill horizontal navigation children using the default navigation
                
                NavigationMenu.forEach((horizontalNavItem) => {
                    defaultNavigationData.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === horizontalNavItem.id) {
                            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Return the response
                return [
                    200,
                    {
                        // compact: cloneDeep(this._compactNavigation),
                        default: cloneDeep(defaultNavigationData),
                        // futuristic: cloneDeep(this._futuristicNavigation),
                        horizontal: cloneDeep(NavigationMenu)
                    }
                ];
            });
    }

}
